<div class="flex flex-col gap-4 py-2">
  <div class="flex w-full items-center justify-start gap-4 px-6">
    <h2 class="text-primary font-['Inter'] text-2xl font-semibold" i18n="@@categoriesSectionTitle">Categories</h2>
    <a
      routerLink="/user/categories"
      class="text-primary pt-1 text-sm font-medium hover:underline"
      i18n="@@categoriesSectionViewAll">
      View All
    </a>
  </div>
  @if (errorMessage()) {
    <div class="text-danger-text px-6 text-center">{{ errorMessage() }}</div>
  } @else {
    <div class="categories-grid flex flex-wrap justify-center gap-6 px-6 py-4 md:justify-start">
      @if (categories) {
        @for (category of categories.list; track category.id) {
          <div
            (click)="viewCategory(category)"
            class="group hover-shadow-primary-10 relative flex h-52 w-44 cursor-pointer flex-col items-center overflow-hidden rounded-[1.8rem] border border-gray-50 bg-white p-4 shadow-[0_8px_30px_rgb(0,0,0,0.04)] transition-all duration-500 hover:-translate-y-1.5">
            <div
              class="relative z-10 mb-3 flex h-32 w-32 items-center justify-center overflow-hidden rounded-2xl bg-gray-50/50 shadow-inner transition-all duration-500 group-hover:bg-white">
              @let imageData = categoryImages.get(category.id);

              @if (imageData && imageData.isImage) {
                <img
                  [src]="imageData.url"
                  class="h-full w-full scale-90 object-contain p-1 transition-transform duration-700 group-hover:scale-110" />
              } @else {
                <svg
                  class="text-danger-text h-20 w-20 opacity-90 transition-transform duration-500 group-hover:scale-110"
                  viewBox="0 0 48 48">
                  <g fill="currentColor">
                    <path d="M37.084 15.735a1 1 0 1 0 .448-1.949l-6.616-1.52a1 1 0 1 0-.448 1.948z" />
                    <path
                      fill-rule="evenodd"
                      d="M34 22a8 8 0 1 0 0-16a8 8 0 0 0 0 16m0-2a6 6 0 1 0 0-12a6 6 0 0 0 0 12M16.778 9.245c-.647-1.532-2.813-1.686-3.682-.263L6.292 20.115c-.785 1.284.092 2.924 1.623 3.033l11.866.846c1.53.11 2.644-1.388 2.06-2.77zm-1.967.768l-.009.012L8.01 21.14l.002.002l.01.004a.1.1 0 0 0 .036.007l11.867.846h.038a.1.1 0 0 0 .029-.015l-5.056-11.96l-.004-.01a.1.1 0 0 0-.054-.014a.13.13 0 0 0-.062.009l-.003.001v.001zM35.385 36.36a6 6 0 0 0-5.071-10.876l-10.876 5.07a6 6 0 1 0 5.071 10.877zm-15.102-3.992a4 4 0 1 0 3.381 7.25l4.466-2.083l-3.38-7.25zm9.66 4.322l-3.381-7.25l4.597-2.144a4 4 0 1 1 3.38 7.25z"
                      clip-rule="evenodd" />
                  </g>
                </svg>
              }
            </div>

            <div class="flex w-full flex-1 items-center justify-center">
              <span
                class="group-hover-text-primary relative z-10 line-clamp-2 px-1 text-center text-[14px] leading-[1.2] font-bold text-gray-800 transition-colors duration-300">
                {{ locale() == "ar" ? category.titleAr : category.titleEn }}
              </span>
            </div>

            <div
              class="bg-glow-primary-secondary absolute -right-10 -bottom-10 h-28 w-28 rounded-full blur-2xl transition-transform duration-700 group-hover:scale-150"></div>

            <div
              class="bg-gradient-primary-secondary absolute bottom-0 left-0 h-1 w-0 rounded-full transition-all duration-500 group-hover:w-full"></div>
          </div>
        }
      }
    </div>
  }
</div>
